import axios from 'axios';
import { API_BASE_URL } from '../../../config';
import PaymentMethodSettings from '@/views/Settings/PaymentMethodSettings';

const PaymentRailsTab = ({ organizationId }) => {
  const onSave = async (formValues) => {
    try {
      await axios.put(
        `${API_BASE_URL}/settings/organization/update/${organizationId}`,
        formValues,
      );
    } catch (error) {
      console.error('Error updating settings:', error);
    }
  };

  const getOrganizationPaymentSettings = async () => {
    const res = await axios.get(
      `${API_BASE_URL}/settings/organization/${organizationId}`,
    );
    return res.data;
  };

  return (
    <div>
      <PaymentMethodSettings
        onSave={onSave}
        fetchFormValues={getOrganizationPaymentSettings}
      />
    </div>
  );
};

export default PaymentRailsTab;
